import useTenantStore from '@/app/store/tenant.store';

export const useTenant = () => {
  const {
    currentTenant,
    availableTenants,
    isLoading,
    error,
    switchTenant,
    loadTenants,
  } = useTenantStore();

  return {
    currentTenant,
    availableTenants,
    isLoading,
    error,
    switchTenant,
    loadTenants,
  };
};

export const useCurrentTenant = () => {
  const currentTenant = useTenantStore((state) => state.currentTenant);
  return currentTenant;
};

export const useTenantId = (): string | null => {
  const currentTenant = useTenantStore((state) => state.currentTenant);
  return currentTenant?.id ?? null;
};

export const useTenantSettings = () => {
  const currentTenant = useTenantStore((state) => state.currentTenant);
  return currentTenant?.settings ?? null;
};

export const useIsTenantFeatureEnabled = (feature: keyof NonNullable<ReturnType<typeof useTenantSettings>>['features']): boolean => {
  const settings = useTenantSettings();
  return settings?.features?.[feature] ?? false;
};

export default useTenant;